import { useEffect, useState } from 'react';
import { FormattedMessage, } from 'react-intl';
import { isEmpty } from 'lodash';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button, Form, Input, Alert, Carousel } from 'antd';

import { GetHomeParams, RootState, getAccountUsernameFromPath } from '@share/utils';
import { login } from '@share/store/slices';
import { LoginType } from '@share/utils';
import { Routes } from '@share/constants';
import { NULL_VALUE } from '@constants';
import { IAccount } from '@share/common-types';

import './style.scss';
import { LoginPageAshevillePlay } from '../signin-asheville-play';


const IMAGES = [1, 2, 3, 4, 5];

const SPEED = 2000;
const AUTOPLAY_SPEED = 8000;
const SLIDES_TO_SHOW = 1;
const SLIDES_TO_SCROLL = 1;

const propsCarousel = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: SPEED,
  slidesToShow: SLIDES_TO_SHOW,
  slidesToScroll: SLIDES_TO_SCROLL,
  autoplay: true,
  autoplaySpeed: AUTOPLAY_SPEED
};

interface IProps extends RouteComponentProps {}

function SignInComponent(props: IProps) {

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account, widgetRedirect } = loginStore;

  const widgetLogoutRedirect = account?.widgetLogoutRedirect;
  const hasClientCash = account?.hasClientCash;
  const isAshevillePlay = account?.isAshevillePlay;

  const widgetRedirectStore = widgetRedirect;
  const widgetRedirectUrl = widgetLogoutRedirect;
  const widgetRedirectFinal = widgetRedirectStore || widgetRedirectUrl;

  const isPrivateWithLoginAccountType = account?.type === LoginType.PrivateWithLogin;
  const isPrivateWithLogin = account?.type === LoginType.PrivateWithLogin;

  const [username, setUsername] = useState(NULL_VALUE);
  const [password, setPassword] = useState(NULL_VALUE);
  const [accountName, setAccountName] = useState(NULL_VALUE);

  const dispatch = useDispatch();

  useEffect(() => {
    const accountName = getAccountUsernameFromPath(props.history);
    setAccountName(accountName);
  }, []);

  useEffect(() => {
    if (account) {
      if (isPrivateWithLogin) {
        if(widgetRedirectFinal && !isEmpty(widgetRedirectFinal)) {
          window.location.replace(widgetRedirectFinal);
        }
        if (account.isDisableSignIn && account.disableSignInRedirect && !isEmpty(account.disableSignInRedirect)) {
          window.location.replace(account.disableSignInRedirect);
        }
      }
    }
  }, [account]);

  const handleLogin = () => {
    if (!isEmpty(username) && !isEmpty(password)) {
      const params: any = props.match.params;
      dispatch(login(username, password, params?.bookingID));
    }
  }

  const onFinish = (values: any) => {
    setUsername(values.email);
    setPassword(values.password);
    handleLogin();
  };

  const homeParams = GetHomeParams(account as IAccount);

  if (isAshevillePlay) {
    return <LoginPageAshevillePlay />;
  }

  return (
    <div className="login-page row">
      <div className="login-page__carousel">
        <Carousel {...propsCarousel} lazyLoad="ondemand">
          {IMAGES.map((img, i) => (
            <div key={i} className={`login-page__carousel-item image-${img}`}>
            </div>))}
        </Carousel>
      </div>
      <div className="login-box col-sm-4 col-xs-12" style={{ zIndex: 2000 }}>
        <Form
          name="login-form"
          className="login-form"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            label="E-mail"
            rules={[
              { type: 'email', message: <FormattedMessage id="the.input.is.not.valid.email" /> },
              { required: true, message: <FormattedMessage id="please.input.your.email" /> },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="password"
            label={<FormattedMessage id="password" />}
            rules={[{ required: true, message: <FormattedMessage id="please.input.your.password" /> },
            ]}
          >
            <Input.Password />
          </Form.Item>

          {loginStore.error ?
            <Form.Item>
              <Alert message="" description={loginStore.error} type="error" showIcon />
            </Form.Item>: null}

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              <FormattedMessage id="login" />
            </Button>
          </Form.Item>

          {!isPrivateWithLoginAccountType ? (
            <Form.Item>
              <a className="login-form-forgot" href={`${accountName}${Routes.ForgotPassword}`}><FormattedMessage id="forgot.password" /></a>
            </Form.Item>) : null}
          
          {(hasClientCash && !isPrivateWithLoginAccountType) && (
            <Form.Item>
              <a className="login-form-forgot" href={`/${accountName}${Routes.Search}${homeParams}`}><FormattedMessage id="confirmation.go.back_home" /></a>
            </Form.Item>)}

          {!isPrivateWithLoginAccountType ? (
            <Form.Item>
              <FormattedMessage id="dont.have.account" /> <a className="login-form-forgot" href={`${accountName}${Routes.SignUp}`}><FormattedMessage id="sign.up" /></a>
            </Form.Item>) : null}
        </Form>
      </div>
    </div>
  );
}

const SignInComponentRouter = withRouter(SignInComponent);

export const SignIn = connect()(SignInComponentRouter);
